import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";

const UserKYCTable = ({ handleClose, open, userData }) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={"paper"}
        fullWidth={true}
        maxWidth={"sm"}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {" "}
          <h4 className=" text-center">KYC Document</h4>
        </DialogTitle>
        <DialogContent dividers={"paper"}>
          <div>
            <div className="max-w-4xl ">
              <div className="w-full grid grid-cols-2 gap-6 mt-4">
                <div className="text-right font-semibold">
                  Aadhar Card No. :
                </div>
                <div className="">{userData?.aadhaarNumber || "N/A"}</div>
                <div className="text-right font-semibold">Pan Card No. :</div>
                <div className="">{userData?.panCardNumber || "N/A"}</div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            type="button"
            onClick={handleClose}
            className={`btn btn-danger `}
          >
            Close
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserKYCTable;
